<template>
  <div>
    <SimpleTextPopup
      :title="$t('PleaseEnterYourEmailAddress')"
      v-model="value"
      :showTextbox="true"
      :rightButtonText="$t('sendEmail')"
      @popupClose="$emit('input', false)"
      :rightMethod="sendResetPasswordEmail"
      small
    >
      <template v-slot:input>
        <div>
          <v-text-field
          prepend-icon="mail" 
          name="input-3"
          label="email"
          v-model="email"
          :rules="[fieldIsEmail(), fieldIsRequired('email')]"
          ref="thepopup"
        ></v-text-field>
        </div>
      </template>
      <template v-slot:popupAction>
        <v-layout row justify-space-between>
          <v-flex class="text-xs-left">
            <v-btn color="primary" flat @click.stop="$emit('input', false)">{{
              $t('close')
            }}</v-btn>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-layout>
              <v-flex xs8>
                <v-tooltip top v-if="isNonVPN">
                  <template v-slot:activator="tooltip">
                    <div v-on="tooltip.on">
                      <v-btn
                        icon
                        @click.stop="isShowParseUrlPopup = true"
                        color="primary"
                        flat
                        ><v-icon>fast_forward</v-icon></v-btn
                      >
                    </div>
                  </template>
                  {{ $t('parseUrl') }}
                </v-tooltip>
              </v-flex>
              <v-flex>
                <v-btn flat color="primary" @click="sendResetPasswordEmail">{{
                  $t('send')
                }}</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </SimpleTextPopup>
    <ParseSignupUrlPopup v-model="isShowParseUrlPopup" :email="email" />
  </div>
</template>

<script>
import SimpleTextPopup from '@/components/SimpleTextPopup'
import ParseSignupUrlPopup from '@/components/ParseSignupUrlPopup'
import LoaderButton from '@/components/LoaderButton'
import {checkRules} from '@/utils/tools'
export default {
  components: {
    SimpleTextPopup,
    ParseSignupUrlPopup,
    LoaderButton
  },
  mixins: [checkRules],
  props: {
    value: Boolean
  },
  data () {
    return {
      email: '',
      isShowParseUrlPopup: false
    }
  },
  computed: {
    isNonVPN () {
      return this.$store.getters.isNonVPN
    }
  },
  methods: {
    sendResetPasswordEmail () {
      return this.dispatchAndToast(this.$store.dispatch('sendPasswordResetEmail', this.email), 'Reset email has been sent')
        .then(() => {
        })
    },
    dispatchAndToast (promise, actionText) {
      return promise
        .then(() => {
          this.$store.dispatch('showToast', {info: this.$t('resetPasswordToast'), level: 'success'})
        })
        .catch(error => {
          this.$store.dispatch('showToast', {info: `${actionText} failed. ` + error.message})
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResetPasswordEmailPopup.vue